var cartMeta = {};

var CartUtils = function(){

    var isLoading;

    var _isLoading = function(){
        return isLoading;
    }

    var _setLoading = function(loading) {
        if (loading) {
            isLoading = true;
            $("#pay-button").prop('disabled',true);
            $("#pay-button-spinner").removeClass("hidden");
            $("#pay-button-text").addClass("hidden");
        } else {
            isLoading = false;
            $("#pay-button").prop('disabled',false);
            $("#pay-button-spinner").addClass("hidden");
            $("#pay-button-text").removeClass("hidden");
        }
    }

    var _showMessage = function(messageText) {
        $("#payment-message").removeClass("hidden");
        $("#payment-message").text(messageText);
      
        setTimeout(function () {
            $("#payment-message").addClass("hidden");
            $("#payment-message").empty();
        }, 4000);
    }

    var _checkStatus = function( clientSecret ){
        var { paymentIntent } = stripe.retrievePaymentIntent(clientSecret).then(
            fn => {
                switch (paymentIntent.status) {
                  case "succeeded":
                    CartUtils.showMessage("Payment succeeded!");
                    break;
                  case "processing":
                    CartUtils.showMessage("Your payment is processing.");
                    break;
                  case "requires_payment_method":
                    CartUtils.showMessage("Your payment was not successful, please try again.");
                    break;
                  default:
                    CartUtils.showMessage("Something went wrong.");
                    break;
                }
            }
        );

    }

    var _meta = function( data ){
        if( typeof data !== 'object' ){
            data = cartMeta;
        }else{
            return cartMeta;
        }
    }

    var _prepareStripe = function( response ){
        stripe = Stripe(response.pk);
        elements = stripe.elements({clientSecret:response.cs});
        var paymentElement = elements.create("payment", {}  );
        paymentElement.mount( response.el );
    }
    
    return {
        isLoading: function(){
            _isLoading();
        },
        setLoading: function(bool){
            _setLoading(bool)
        },
        showMessage: function(t){
            _showMessage(t)
        },
        checkStatus: function(cs){
            _checkStatus(cs)
        },
        mountPayElement: function(r){
            _prepareStripe(r);
        },
        meta: function(d){
            _meta(d);
        }
    }
}();

async function handleCartSubmit(e){
    e.preventDefault();
    CartUtils.setLoading(true);
    var { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
            return_url: ecomConf.returnUrl,
        },
    });
    if( typeof error !== 'undefined' ){
        if (error.type === "card_error" || error.type === "validation_error") {
            CartUtils.showMessage(error.message);
        } else {
            CartUtils.showMessage("An unexpected error occurred.");
        }
    }

    CartUtils.setLoading(false);
}